import { body, request } from "services/request";

const resource = "api/suitableOrders";

const apply = (params: {}) => request(`${resource}/apply`, body(params), { withoutMiddleware: true });

const setRedirectStatus = (params: {}) =>
    request(`${resource}/setRedirectStatus`, body(params), { withoutMiddleware: true });

export { apply, setRedirectStatus };
